<template>
  <Main :name="name" :value="value" :options="options" :effect="effect" :color="color" :round="round" :size="size" :type="type"></Main>
</template>

<script>
import Main from './main.vue'

export default {
  components: { Main },
  props: {
    // 字典索引
    name: String,
    // 当前的值
    value: [Number, String, Array],
    // 颜色
    color: String,
    // 主题
    effect: String,
    // 圆形
    round: Boolean,
    // 尺寸
    size: String,
    // 类型
    type: String,
    // 数据
    options: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  },
}
</script>
